import React, { useState, useEffect } from 'react';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`}>
      <div className="container mx-auto flex justify-between items-center">
        <a href="#home" className="text-2xl font-serif font-bold text-primary">
          Raquel de Araujo
        </a>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8">
          <a href="#home" className="text-neutral-dark hover:text-primary transition-colors">Home</a>
          <a href="#services" className="text-neutral-dark hover:text-primary transition-colors">Serviços</a>
          <a href="#about" className="text-neutral-dark hover:text-primary transition-colors">Sobre</a>
          <a href="#portfolio" className="text-neutral-dark hover:text-primary transition-colors">Portfólio</a>
          <a href="#contact" className="text-neutral-dark hover:text-primary transition-colors">Contato</a>
        </div>

        {/* CTA Button */}
        <div className="hidden md:block">
          <a 
            href="https://wa.me/5541999119143?text=Olá,%20gostaria%20de%20agendar%20uma%20consultoria." 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-primary"
          >
            Agende uma Consultoria
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-neutral-dark hover:text-primary text-xl"
          onClick={toggleMenu}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white absolute top-full left-0 w-full shadow-md py-4 px-4 transition-all duration-300">
          <div className="flex flex-col space-y-4">
            <a 
              href="#home" 
              className="text-neutral-dark hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </a>
            <a 
              href="#services" 
              className="text-neutral-dark hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Serviços
            </a>
            <a 
              href="#about" 
              className="text-neutral-dark hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Sobre
            </a>
            <a 
              href="#portfolio" 
              className="text-neutral-dark hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Portfólio
            </a>
            <a 
              href="#contact" 
              className="text-neutral-dark hover:text-primary transition-colors"
              onClick={() => setIsMenuOpen(false)}
            >
              Contato
            </a>
            <a 
              href="https://wa.me/5541999119143?text=Olá,%20gostaria%20de%20agendar%20uma%20consultoria." 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Agende uma Consultoria
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 